/**
 * Strips HTML tags, collapses whitespace, and truncates to ~157 chars
 * for safe use in <meta name="description"> tags.
 */
export function sanitiseMetaDescription(text: string): string {
  const stripped = text
    .replace(/<[^>]*>/g, "")
    .replace(/\s+/g, " ")
    .trim();

  if (stripped.length <= 157) return stripped;
  return stripped.slice(0, 154) + "…";
}
